import api from "./api";

export const fetchAspirantsByEglise = async (egliseId) => {
  try {
    const res = await api.get(`/aspirants/aspirants?eglise_id=${egliseId}`);
    return res.data?.aspirants || [];
  } catch (err) {
    console.error("Erreur lors du fetch des aspirants :", err);
    throw err;
  }
};

export const addAspirant = async (aspirantData) => {
  try {
    // Si c'est un FormData, axios gère automatiquement le Content-Type avec la bonne boundary
    // Ne PAS définir Content-Type manuellement, sinon la boundary sera manquante
    await api.post("/aspirants", aspirantData);
  } catch (err) {
    console.error("Erreur lors de l'ajout d'un élève :", err);
    throw err;
  }
};

export const updateAspirant = async (aspirantId, aspirantData) => {
  try {
    // Si c'est un FormData, axios gère automatiquement le Content-Type avec la bonne boundary
    await api.put(`/aspirants/${aspirantId}`, aspirantData);
  } catch (err) {
    console.error("Erreur lors de la mise à jour d'un élève :", err);
    throw err;
  }
};

export const fetchEgliseInfo = async () => {
  try {
    const res = await api.get("/auth/me");
    return res.data;
  } catch (err) {
    console.error("Erreur lors du fetch des infos église :", err);
    throw err;
  }
};

export const fetchAspirantsByRegion = async () => {
  try {
    const res = await api.get("/region/aspirants");
    return res.data || [];
  } catch (err) {
    console.error("Erreur lors du fetch des aspirants de la région :", err);
    throw err;
  }
};

export const fetchAllValidatedAspirants = async () => {
  try {
    const res = await api.get("/aspirants/validated");
    return res.data?.aspirants || [];
  } catch (err) {
    console.error("Erreur lors du fetch de tous les aspirants validés :", err);
    throw err;
  }
};
